// extracted by mini-css-extract-plugin
module.exports = {"logo":"SimplePromo--logo--1m-fn"};